var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 21.2,
    r: 2.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.2,
    r: 2.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 21.2,
    r: 2.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.9,9.5H9.1c-3.6,0-6.6,2.9-6.6,6.6v67.9c0,3.6,2.9,6.6,6.6,6.6h81.9c3.6,0,6.6-2.9,6.6-6.6V16.1C97.5,12.5,94.6,9.5,90.9,9.5zM9.1,14.6h81.9c0.8,0,1.5,0.7,1.5,1.5v11.7H7.6V16.1C7.6,15.3,8.3,14.6,9.1,14.6zM90.9,85.4H9.1c-0.8,0-1.5-0.7-1.5-1.5V32.8h84.8v51.1C92.4,84.7,91.7,85.4,90.9,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.8,54.8c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7l2.8-2.8l2.8,2.8c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7c1-1,1-2.6,0-3.6l-2.8-2.8l2.8-2.8c1-1,1-2.6,0-3.6s-2.6-1-3.6,0l-2.8,2.8l-2.8-2.8c-1-1-2.6-1-3.6,0c-1,1-1,2.6,0,3.6l2.8,2.8l-2.8,2.8C31.8,52.2,31.8,53.8,32.8,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M67.2,42.1c-1-1-2.6-1-3.6,0l-2.8,2.8l-2.8-2.8c-1-1-2.6-1-3.6,0s-1,2.6,0,3.6l2.8,2.8l-2.8,2.8c-1,1-1,2.6,0,3.6c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7l2.8-2.8l2.8,2.8c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7c1-1,1-2.6,0-3.6l-2.8-2.8l2.8-2.8C68.2,44.7,68.2,43.1,67.2,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.9,62.4H35.1c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5h14.1v5.1c0,3.7,3,6.6,6.6,6.6s6.6-3,6.6-6.6v-5.1h2.4     c1.4,0,2.5-1.1,2.5-2.5C67.4,63.5,66.3,62.4,64.9,62.4z M57.4,72.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6v-5.1h3.1V72.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.2a9e51d68a80cc07da1732ac4c0987b8.svg";
export { ForwardRef as ReactComponent };